export default __webpack_public_path__ + "media/zurb/img/events/wired/second-harvest/second-harvest-thumb-40df51dd17b4993996e07eea19174e9e.png";